import Component from '../vendor/Component'

export default class HotSpots extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._triggers = this._elem.querySelectorAll('[data-hotspots-el="trigger"]')
    this._modal = this._elem.querySelector('[data-hotspots-el="modal"]');
  }

  mount() {
    this.setupListeners()
  }

  setupListeners() {
    this.handleTrigger = this.handleTrigger.bind(this)

    this._triggers.forEach(trigger => {
      trigger.addEventListener('click', this.handleTrigger)
    });
  }

  async handleTrigger (event) {
    event.stopImmediatePropagation()
    const trigger = event.target
    this.activateTrigger(trigger)

    try {
      const sectionsUrl = trigger.dataset.productUrl
      const [path, querystring = ''] = sectionsUrl.split('?');

      const params = new URLSearchParams(querystring);
      params.set('section_id', 'hotspot-product');

      const response = await fetch(`${path}?${params.toString()}`);
      const res = await response.text();

      const newDOM = new DOMParser().parseFromString(res, 'text/html')
      const bodyContent = newDOM.querySelector('[data-hotspots-el="product"]');

      this._modal.innerHTML = bodyContent.outerHTML;

      this.initForm()
      this.positionModal(trigger)

    } catch (error) {
      console.error(error);
    }
  }

  initForm () {
    const formEl = this._elem.querySelector('form')
    const sizeSelectEl = formEl.querySelector('[data-hotspots-el="size-select"]')
    const closeModal = this._elem.querySelector('[data-hotspots-el="close"]')

    sizeSelectEl.addEventListener('change', this.handleSizeOptionChange.bind(this))
    closeModal.addEventListener('click', this.handleCloseEvent.bind(this))
    formEl.addEventListener('submit', this.handleFormSubmit.bind(this))
  }

  handleSizeOptionChange (event) {
    const selectEl = event.target
    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const selectedSizeId = selectedOption.getAttribute('data-variant-id');
    const sizeInput = this._elem.querySelector('input[name="id"]')

    const submitButton = this._elem.querySelector('[data-hotspots-el="formSubmit"]')

    if (selectedOption.hasAttribute('data-default-option')) {
      submitButton.disabled = true;
    } else {
      sizeInput.value = selectedSizeId
      submitButton.disabled = false;
    }
  }

  handleFormSubmit (event) {
    event.preventDefault();
    const sizeVariant = this._elem.querySelector('input[name="id"]')

    const formData = {
      'items': [{
        'id': sizeVariant.value,
        'quantity': 1
      }]
    };

    window.Cart.add(formData);
    this._modal.classList.remove('is-active')
  }

  activateTrigger (trigger) {
    this._triggers.forEach((item) => {
      if (item === trigger) {
        item.classList.add('is-active')
      } else {
        item.classList.remove('is-active')
      }
    })
  }

  handleCloseEvent () {
    this._triggers.forEach((item) => {
      item.classList.remove('is-active')
    })

    this._modal.classList.remove('is-active')
  }

  positionModal (trigger) {
    if (window.innerWidth > 768) {
      const rect = trigger.getBoundingClientRect();
      const containerRect = trigger.closest('[data-hotspots-el="container"]').getBoundingClientRect();

      const modalWidth = 425;
      const modalHeight = 150; // rough estimate of height
      const spacing = 20;

      let left = rect.left - containerRect.left + spacing + 55;
      let top = rect.top - containerRect.top - modalHeight / 2 + trigger.offsetHeight / 2 + 45;

      // Adjust if overflowing right edge
      if (left + modalWidth > containerRect.width) {
        left = rect.left - containerRect.left - modalWidth - spacing;
      }

      // Adjust if overflowing top/bottom
      if (top < 0) {
        top = 0;
      }

      if (top + modalHeight > containerRect.height) {
        top = containerRect.height - modalHeight - 10;
      }

      this._modal.style.top = `${top}px`;
      this._modal.style.left = `${left}px`;
    }

    this._modal.classList.add('is-active')
  }
}
